export default __webpack_public_path__ + "static/media/Bandit's Belt of Woven Clouds.a43f1c66.jpg";